module.exports = __webpack_public_path__ + "static/media/logo.8b7e7b01.svg";